import React from "react"
import { navigate } from "@reach/router"

const ComiteRegionalIndex: React.FC = () => {
  setTimeout(() => navigate("./equipe/", { replace: true }), 0)
  return <></>
}

export default ComiteRegionalIndex
